declare const __GX_REACT_SDK_VERSION__: string | undefined;

const reactSdkVersion =
	typeof __GX_REACT_SDK_VERSION__ === "string"
		? __GX_REACT_SDK_VERSION__.trim()
		: "";

// Build scripts inject __GX_REACT_SDK_VERSION__ for published artifacts.
// Source-linked workspace usage may not inject defines, so keep a safe fallback.
export const REACT_SDK_VERSION =
	reactSdkVersion.length > 0 ? reactSdkVersion : "0.0.0-local";
